function ManualAlert({ type = 'info', title, children }) {
  const icons = {
    info: 'bi-info-circle',
    success: 'bi-check-circle',
    warning: 'bi-exclamation-triangle',
    tip: 'bi-lightbulb',
    important: 'bi-star'
  };

  return (
    <div className={`manual-alert manual-alert-${type}`}>
      <div className="manual-alert-icon">
        <i className={`bi ${icons[type]}`}></i>
      </div>
      <div className="manual-alert-content">
        {title && <strong className="manual-alert-title">{title}</strong>}
        <div>{children}</div>
      </div>
    </div>
  );
}

export default ManualAlert;
